export default __webpack_public_path__ + "static/media/mangrove.aec9d8fe.jpg";